const PREFIX = 'performance';

const itemPath = (index: number) => `${PREFIX}-item-${index + 1}`;

export const SPARTAN_PRODUCT_ENGINE_TRACKING = {
  section: PREFIX,
  header: `${PREFIX}-header`,
  title: `${PREFIX}-title`,
  tabs: `${PREFIX}-tabs`,
  /** Used with SpartanTabs as `${tabPrefix}-${index + 1}`. */
  tabPrefix: `${PREFIX}-tab`,
  tab: (index: number) => `${PREFIX}-tab-${index + 1}`,
  cta: `${PREFIX}-cta`,

  item: (index: number) => itemPath(index),
  itemTitle: (index: number) => `${itemPath(index)}-title`,
  itemDescription: (index: number) => `${itemPath(index)}-description`,
  itemPanelRemark: (index: number) => `${itemPath(index)}-panel-remark`,
  itemLogo: (index: number) => `${itemPath(index)}-logo`,
  /** Stage media wrapper (`SpartanInViewVideo` / image frame). */
  itemMedia: (index: number) => `${itemPath(index)}-media`,
  /** Video element when stage media includes video. */
  itemMediaVideo: (index: number) => `${itemPath(index)}-media-video`,
  itemRemark: (index: number) => `${itemPath(index)}-remark`,

  itemSpecList: (index: number) => `${itemPath(index)}-spec-list`,
  itemSpec: (itemIndex: number, specIndex: number) =>
    `${itemPath(itemIndex)}-spec-${specIndex + 1}`,
  itemSpecLabel: (itemIndex: number, specIndex: number) =>
    `${itemPath(itemIndex)}-spec-${specIndex + 1}-label`,
  itemSpecValue: (itemIndex: number, specIndex: number) =>
    `${itemPath(itemIndex)}-spec-${specIndex + 1}-value`,
  itemSpecUnit: (itemIndex: number, specIndex: number) =>
    `${itemPath(itemIndex)}-spec-${specIndex + 1}-unit`,
} as const;

export const SPARTAN_PRODUCT_ENGINE_DATA_GA = {
  section: PREFIX,
  tab: 'tab',
  cta: 'cta',
} as const;
